import { StyleSheet } from "@react-pdf/renderer";

export const transportationDocumentStyles=()=>{

    const transportationDocumentData = StyleSheet.create({

        container: {
            width: '100%',
            height:150,
            alignSelf: 'center',
            borderTopWidth: 1,
            borderLeftWidth: 1,
            borderBottomWidth: 1,
            borderColor: 'black',
            flexDirection: 'column'
        },
        titleContainer: {
            width: '100%',
            height: '15%',
            justifyContent: 'center',
            alignItems: 'center',
            borderRightWidth: 1,
            borderBottomWidth: 1,
            borderColor: 'black'
        },
        title: {
            fontSize: 7,
            fontWeight: 700
        },
        firstRow: {
            height: '35%',
            borderBottomWidth: 1,
            flexDirection: 'row'
        },
        secondRow: {
            height: '50%',
            flexDirection: 'row'
        }
    })

    const transportationDocumentSecondSection = StyleSheet.create({
        container: {
            width: '25%',
            borderColor: 'black',
            borderRightWidth: 1,
            flexDirection: 'column'
        },
        titleContainer: {
            borderBottomWidth: 1,
            height: '20%',
            justifyContent: 'center',
            alignItems: 'center'
        },
        title:{
            fontSize: 6, 
            fontWeight: 700 
        },
        subContainer: {
            flexDirection: 'column',
            gap: 3,
            padding: 2,
        },
        field: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap:5
        },
        concept:{
            fontSize: 5, 
            fontWeight: 700
        }
    })

    const transportationDocumentFirstSection = StyleSheet.create({
        container: {
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 2,
            borderRightWidth: 1,
            borderColor: 'black'
        },
        field: {
            flexDirection: 'row',
            justifyContent: 'space-between'
        }
    })

    const transportationDocumentLocationsData = StyleSheet.create({

        container: {
            width: '100%',
            borderWidth:1,
            marginTop: 2
        },
        titleContainer: {
            minHeight:20,
            width: '100%',
            paddingVertical: 2,
            justifyContent: 'center',
            alignItems: 'center',
            borderBottomWidth: 1,
        },
        title: {
            fontSize: 7,
            fontWeight: 700
        },
        tableContainer: {
            minHeight:20,
            width: '100%',
        },
        titleRow: {
            flexDirection: 'row',
            minHeight:20,
        },

        firstConceptField:{
            width: '6%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        rfcConcept:{
            width: '9%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        businessNameConcept:{   
            width: '8%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        countryConcept:{
            width: '9%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        stateConcept:{
            width: '13%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        cityConcept:{
            width: '13%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        addressConcept:{
            width: '18%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        postalCodeConcept:{
            width: '6%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        dateConcept:{
            width: '11%', 
            fontSize: 5.5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 700
        },
        distanceConcept:{
            width: '7%', 
            fontSize: 5.5, 
            padding: 4, 
            fontWeight: 700
        },
        telephoneConcept:{
            width: '8%', 
            fontSize: 5.5, 
            padding: 4, 
            fontWeight: 700
        },
        subtitle: {
            fontSize: 5.5,
            borderRightWidth: 1,
            padding: 4,
            borderBottomWidth: 1
        },
        row: {
            minheight:20,
            flexDirection: 'row',
            borderTopWidth:1
        },
        firstDataField:{
            width: '6%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        rfcData:{
            width: '9%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        businessNameData:{
            width: '8%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        countryData:{
            width: '9%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        stateData:{
            width: '13%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        cityData:{
            width: '13%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        addressData:{
            width: '18%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
            fontWeight: 500
        },
        postalCodeData:{
            width: '6%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        dateData:{
            width: '11%', 
            fontSize: 5, 
            borderRightWidth: 1, 
            padding: 4, 
        },
        distanceData:{
            width: '7%', 
            fontSize: 5, 
            padding: 4, 
        },
    })

    return {        
        transportationDocumentData,
        transportationDocumentSecondSection,
        transportationDocumentFirstSection,
        transportationDocumentLocationsData
    }
}